import { useFormatters, useTranslation } from "@ferrivia/i18n";
import { Button, Text } from "@ferrivia/ui";
import { ANALYSIS_SLUG } from "../../../components/AnalysisPurchase";
import { useCatalog } from "../../../hooks/useCatalog";
import s from "./SupportSteps.module.css";

/** The alkukartoitus offer heading the support steps card while it is
    unpaid: what it includes, what it does not, its price and the order
    button. The same for every client — nothing here reads the steps below
    it, let alone a measured value. */
export function AnalysisOffer({ stepsTitle, onOrder }: { stepsTitle: string; onOrder: () => void }) {
  const { t } = useTranslation("client");
  const { currencyEur } = useFormatters();
  const { state } = useCatalog();

  // Left out rather than shown blank or zero while the catalog loads or has
  // no price; the order sheet says so itself if the product is unavailable.
  const price =
    state.status === "success"
      ? state.data.products.find((product) => product.slug === ANALYSIS_SLUG)?.prices[0]
      : undefined;

  return (
    <div className={s.offer}>
      <ul className={s.includes}>
        <li className={s.includesItem}>{t("support.purchase.includes.analysis", "Alkukartoitusraportti")}</li>
        <li className={s.includesItem}>{t("support.purchase.includes.call", "Alkukartoituksen henkilökohtainen läpikäyntipuhelu")}</li>
        <li className={s.includesItem}>{t("support.purchase.includes.plan", "Henkilökohtainen suunnitelma")}</li>
      </ul>

      <Text as="p" size="sm" className={s.labsNote}>
        {t(
          "support.offer.labsNote",
          "Verikokeet eivät sisälly hintaan. Tarvitset enintään kuukauden vanhat tulokset. Voit tilata kokeet meiltä tai lisätä omat tulokset.",
        )}
      </Text>

      <div className={s.order}>
        {price && (
          <span className={s.price}>
            <span className={s.priceLabel}>{t("support.offer.priceLabel", "Hinta")}</span>
            <span className={s.priceAmount}>{currencyEur.format(price.unitAmountCents / 100)}</span>
          </span>
        )}
        <Button variant="primary" onClick={onOrder}>
          {t("support.offer.cta", "Tilaa alkukartoitus")}
        </Button>
      </div>

      {/* The card's own h2 is the product while this shows, so the steps
          get a heading of their own one level down. */}
      <Text as="h3" size="xs" weight="medium" className={s.stepsHeading}>
        {stepsTitle}
      </Text>
    </div>
  );
}
